export class ConfirmationModal{ 
    
    headerMessage:string;
    bodyMessage:string;

}


// WEBPACK FOOTER //
// ./src/app/modules/eldm-param-value/entities/confirmation-modal.ts